/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "./type";
/**
 * Describes available positions on the X axis at which the summary tooltip to be displayed.
 */
export var DataTooltipGroupedPositionX = /*@__PURE__*/ (function (DataTooltipGroupedPositionX) {
    /**
     * A position on the X axis is selected automatically.
     */
    DataTooltipGroupedPositionX[DataTooltipGroupedPositionX["Auto"] = 0] = "Auto";
    /**
     * Aligns the tooltip so that it appears to the left of the horizontal snap point of the current series if applicable.
     */
    DataTooltipGroupedPositionX[DataTooltipGroupedPositionX["SnapLeft"] = 1] = "SnapLeft";
    /**
     * Aligns the tooltip so that it appears to the right of the horizontal snap point of the current series if applicable.
     */
    DataTooltipGroupedPositionX[DataTooltipGroupedPositionX["SnapRight"] = 2] = "SnapRight";
    /**
     * Aligns the tooltip so that it appears at the middle of the horizontal snap point of the current series if applicable.
     */
    DataTooltipGroupedPositionX[DataTooltipGroupedPositionX["SnapMiddle"] = 3] = "SnapMiddle";
    /**
     * Aligns the tooltip so that it appears to the left of the horizontal snap point of the current series if applicable.
     */
    DataTooltipGroupedPositionX[DataTooltipGroupedPositionX["LeftEdgeSnapLeft"] = 4] = "LeftEdgeSnapLeft";
    /**
     * Aligns the tooltip so that it appears to the right of the horizontal snap point of the current series if applicable.
     */
    DataTooltipGroupedPositionX[DataTooltipGroupedPositionX["LeftEdgeSnapRight"] = 5] = "LeftEdgeSnapRight";
    /**
     * Aligns the tooltip so that it appears at the middle of the horizontal snap point of the current series if applicable.
     */
    DataTooltipGroupedPositionX[DataTooltipGroupedPositionX["LeftEdgeSnapMiddle"] = 6] = "LeftEdgeSnapMiddle";
    /**
     * Aligns the tooltip so that it appears to the left of the horizontal snap point of the current series if applicable.
     */
    DataTooltipGroupedPositionX[DataTooltipGroupedPositionX["RightEdgeSnapLeft"] = 7] = "RightEdgeSnapLeft";
    /**
     * Aligns the tooltip so that it appears to the right of the horizontal snap point of the current series if applicable.
     */
    DataTooltipGroupedPositionX[DataTooltipGroupedPositionX["RightEdgeSnapRight"] = 8] = "RightEdgeSnapRight";
    /**
     * Aligns the tooltip so that it appears at the middle of the horizontal snap point of the current series if applicable.
     */
    DataTooltipGroupedPositionX[DataTooltipGroupedPositionX["RightEdgeSnapMiddle"] = 9] = "RightEdgeSnapMiddle";
    /**
     * Aligns the tooltip so that it appears to the left of the cursor.
     */
    DataTooltipGroupedPositionX[DataTooltipGroupedPositionX["TrackLeft"] = 10] = "TrackLeft";
    /**
     * Aligns the tooltip so that it appears to the right of the cursor.
     */
    DataTooltipGroupedPositionX[DataTooltipGroupedPositionX["TrackRight"] = 11] = "TrackRight";
    /**
     * Aligns the tooltip so that the cursor appears in the center of the tooltip width.
     */
    DataTooltipGroupedPositionX[DataTooltipGroupedPositionX["TrackMiddle"] = 12] = "TrackMiddle";
    /**
     * Aligns the tooltip relative to the left plot area edge.
     */
    DataTooltipGroupedPositionX[DataTooltipGroupedPositionX["PinLeft"] = 13] = "PinLeft";
    /**
     * Aligns the tooltip relative to the right plot area edge.
     */
    DataTooltipGroupedPositionX[DataTooltipGroupedPositionX["PinRight"] = 14] = "PinRight";
    /**
     * Aligns the tooltip width center with the width center of the plot area.
     */
    DataTooltipGroupedPositionX[DataTooltipGroupedPositionX["PinMiddle"] = 15] = "PinMiddle";
    return DataTooltipGroupedPositionX;
})({});
/**
 * @hidden
 */
export var DataTooltipGroupedPositionX_$type = /*@__PURE__*/ markEnum('DataTooltipGroupedPositionX', 'Auto,0|SnapLeft,1|SnapRight,2|SnapMiddle,3|LeftEdgeSnapLeft,4|LeftEdgeSnapRight,5|LeftEdgeSnapMiddle,6|RightEdgeSnapLeft,7|RightEdgeSnapRight,8|RightEdgeSnapMiddle,9|TrackLeft,10|TrackRight,11|TrackMiddle,12|PinLeft,13|PinRight,14|PinMiddle,15');
